import { secondAxios, SECOND_URL } from "../../../../../../api/axios";

// See DCSTab/sharepoint.md - the folder-tree family builds/reads a
// hierarchy under a site's drive root shaped `plantName/projectName/...`.
// siteId is intentionally omitted here: the backend resolves a default via
// resolveSiteId() for this endpoint family, and nothing in the plant/project
// data model stores a Graph siteId (only a free-typed SharePoint web link,
// which is a different, opaque thing).

export async function getPlantFolder(plantName) {
  const res = await secondAxios.get("/sharepoint/plant", {
    params: { name: plantName },
  });
  return res.data;
}

export async function getProjectFolder(plantName, projectName) {
  const res = await secondAxios.get(
    `/sharepoint/plant/${encodeURIComponent(plantName)}/project`,
    { params: { name: projectName } },
  );
  return res.data;
}

export async function getFolder(folderPath) {
  const res = await secondAxios.get("/sharepoint/folder", {
    params: { folderPath },
  });
  return res.data;
}

export async function createPlantFolder(plantName) {
  const res = await secondAxios.post("/sharepoint/plant", { name: plantName });
  return res.data;
}

export async function createProjectFolder(plantName, projectName) {
  const res = await secondAxios.post(
    `/sharepoint/plant/${encodeURIComponent(plantName)}/project`,
    { name: projectName },
  );
  return res.data;
}

export async function createFolder(name, parentPath) {
  const res = await secondAxios.post("/sharepoint/folder", {
    name,
    ...(parentPath ? { parentPath } : {}),
  });
  return res.data;
}

// Builds (or reuses) plantName/projectName/docNum/Rev {revNum} - one POST
// /sharepoint/folder create per level. The backend's plant/project create
// endpoints fail on conflict ("already exists"), and the doc-level folder
// may already exist from an earlier revision of the same document, so every
// level but the last is created best-effort (a conflict there just means
// it's already there); only the final "Rev N" folder's failure is real and
// propagates to the caller.
export async function ensureDocumentRevisionFolder({
  plantName,
  projectName,
  docNum,
  revNum,
}) {
  if (!plantName || !projectName || !docNum || revNum == null || revNum === "") {
    throw new Error("plantName, projectName, docNum and revNum are all required");
  }

  await createPlantFolder(plantName).catch(() => {});
  await createProjectFolder(plantName, projectName).catch(() => {});
  await createFolder(docNum, `${plantName}/${projectName}`).catch(() => {});

  return createFolder(`Rev ${revNum}`, `${plantName}/${projectName}/${docNum}`);
}

// The proxy behind this exists specifically so files can be opened without
// hitting SharePoint's own login/X-Frame-Options restrictions - point a new
// tab (or an <iframe>/blob) straight at it rather than the item's own
// webUrl. `itemWebUrl` must be a full https://*.sharepoint.com URL.
export function getFileViewUrl(itemWebUrl) {
  return `${SECOND_URL}/sharepoint/file?url=${encodeURIComponent(itemWebUrl)}`;
}
